import TopicTwo from "../../../components/platform-contents/meta-trader-4-contents/TopicTwo";

const MetaTrader4ContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__platform">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Traders Choose MetaTrader 4 with The Pips</h1>
            <p>
              Experience seamless, secure, and smart trading with a platform
              trusted by millions worldwide. MT4 on The Pips offers everything
              you need to analyze markets, execute trades, and manage your
              portfolio, all in one intuitive space
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Stability You Can Count On</h4>
                </div>
                <p>
                  Trade with confidence on a platform known for its unmatched
                  reliability and low latency, ensuring every order is executed
                  with precision.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Complete Control Over Your Strategy</h4>
                </div>
                <p>
                  Whether you trade manually or with expert advisors (EAs), MT4
                  gives you full flexibility to design and optimize strategies
                  that match your goals.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Access to Global Markets in One Click</h4>
                </div>
                <p>
                  From forex pairs to precious metals, diversify your trading
                  portfolio effortlessly, all from a single, user-friendly
                  interface.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaTrader4ContentFive;
